import { makeStyles } from '@mui/styles';

const muiStyles = makeStyles(() => ({
    accordionContainer: { boxShadow: 'none' },
    accordionSummary: {
        height: '8rem',
        margin: '-20px 0px !important',
        // minHeight: '42px !important',
        padding: '10px 10px 7px 10px'
    },
    verticalDivider: {
        height: '35px',
        width: '0.5px',
        margin: '0 10px'
    },
    currencyCode: {
        minWidth: '90px',
        fontSize: '2rem',
        fontWeight: 500
    },
    summaryHeader: {
        fontSize: '0.75rem',
        fontWeight: 500,
        color: '#3C4F70'
    },
    summaryContent: {
        fontSize: '1.25rem',
        fontWeight: 500
    },
    detailsContainer: {
        padding: '0',
        minHeight: '160px'
     },
    divider: {
        height: '0.5px',
        marginBottom: '5px'
    },
    details: {
        width: '100%',
        padding: '20px 12px 12px 12px',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '24px'
    },
    detailsBox: {
        width: '100%',
        height: '28px',
        marginBottom: '22px'
    },
    detailsTitle: {
        fontSize: '0.75rem',
        fontWeight: 700,
        color: '#3C4F70',
        height: '22px'
    },
    title: { width: '130px' },
    transactionTitle: { width: '89px' },
    detailsValue: {
        width: '40%',
        height: '28px',
        paddingRight: '20px',
        fontSize: '1.125rem',
        fontWeight: 500
    },
    detailsEquivalent: {
        fontSize: '12px',
        fontWeight: 700
    },
    transactionsBox: {
        width: '36px',
        height: '100%',
        borderRadius: '4px',
        fontSize: '1rem',
        fontWeight: 500,
        textAlign: 'center'
    },
    bgBlue: {
        backgroundColor: '#3C4F70',
        color: '#FFF'
    },
    bgLightBlue: {
        backgroundColor: '#89C4F2',
        color: '#000'
    },
    navPrice: { fontSize: '12px' }
}));

export default muiStyles;